export class OrganisationsSearchField {
    searchField: string;
    keyword: string;
    onlyRootOrganisations: boolean;
    offset: number;
}